// extracted by mini-css-extract-plugin
export default {"placeholder":"EquipmentSetsIndex_placeholder__UvjKN"};